import { notify } from "react-notify-toast";

export const getTagStatus = () => {
  return [
    { value: "unresponded", name: "Unresponded" },
    { value: "accepted", name: "Accepted" },
    { value: "rejected", name: "Rejected" },
    { value: "can", name: "Cancelled" },
  ];
};

export const getTagDates = () => {
  return [
    { value: "inp", name: "In-progress" },
    { value: "fut", name: "Future" },
    { value: "past", name: "Past" },
  ];
};

export const getTagCategories = () => {
  return [
    { value: "tech", name: "Digital Jobs Training", type: "tec" },
    { value: "elt", name: "English Courses", type: "eng" },
    { value: "bsb", name: "Business Services", type: "vet" },
    { value: "chc", name: "Community Services", type: "vet" },
    { value: "fns", name: "Financial Services", type: "vet" },
    { value: "fsk", name: "Foundation Skills", type: "vet" },
    { value: "shb", name: "Hairdressing and Beauty Services", type: "vet" },
    {
      value: "ict",
      name: "Information and Communications Technology/ Digital Jobs Training",
      type: "vet",
    },
    { value: "sit", name: "Tourism, Travel and Hospitality", type: "vet" },
  ];
};

export const getTags = () => {
  return [
    { tag_name: "General English", cat: "ge", type: "elt" },
    { tag_name: "Exam Preparation", cat: "exam", type: "elt" },
    { tag_name: "Management", cat: "manage", type: "elt" },
    { tag_name: "Teacher Training", cat: "tt", type: "elt" },
    { tag_name: "Academic Programs", cat: "academic", type: "elt" },
    { tag_name: "Primary Teaching", cat: "ge", type: "elt" },
    { tag_name: "Secondary Teaching", cat: "ge", type: "elt" },
    { tag_name: "Early Childhood", cat: "ge", type: "elt" },
    { tag_name: "Other English", cat: "ge", type: "elt" },

    { tag_name: "Workplace Skills", cat: "bsb", type: "vet" },
    { tag_name: "Business", cat: "bsb", type: "vet" },
    { tag_name: "Entrepreneurship & New Business", cat: "bsb", type: "vet" },
    { tag_name: "HR Management", cat: "bsb", type: "vet" },
    { tag_name: "Leadership & Management", cat: "bsb", type: "vet" },
    { tag_name: "Marketing & Communication", cat: "bsb", type: "vet" },
    { tag_name: "Project Management & Practice", cat: "bsb", type: "vet" },
    { tag_name: "Community Services", cat: "chc", type: "vet" },
    { tag_name: "Early Childhood Education & Care", cat: "chc", type: "vet" },
    { tag_name: "Education Support", cat: "chc", type: "vet" },
    { tag_name: "Individual Support", cat: "chc", type: "vet" },
    { tag_name: "Ageing Support", cat: "chc", type: "vet" },
    { tag_name: "Disability", cat: "chc", type: "vet" },
    { tag_name: "Community Development", cat: "chc", type: "vet" },
    { tag_name: "Accounts Administration", cat: "fns", type: "vet" },
    { tag_name: "Financial Services", cat: "fns", type: "vet" },
    { tag_name: "Accounting & Bookkeeping", cat: "fns", type: "vet" },
    { tag_name: "Payroll Services", cat: "fns", type: "vet" },
    { tag_name: "Access to Vocational Pathways", cat: "fsk", type: "vet" },
    { tag_name: "Skills for Vocational Pathways", cat: "fsk", type: "vet" },
    {
      tag_name: "Skills for Work & Vocational Pathways",
      cat: "fsk",
      type: "vet",
    },
    { tag_name: "Retail Cosmetics", cat: "shb", type: "vet" },
    { tag_name: "Salon Assistant", cat: "shb", type: "vet" },
    { tag_name: "Beauty Services", cat: "shb", type: "vet" },
    { tag_name: "Make-up", cat: "shb", type: "vet" },
    { tag_name: "Nail Technology", cat: "shb", type: "vet" },
    { tag_name: "Hairdressing", cat: "shb", type: "vet" },
    { tag_name: "Barbering", cat: "shb", type: "vet" },
    { tag_name: "Beauty Therapy", cat: "shb", type: "vet" },
    { tag_name: "Salon Management", cat: "shb", type: "vet" },
    {
      tag_name: "Intense Pulsed Light and Laser for Hair Reduction",
      cat: "shb",
      type: "vet",
    },
    { tag_name: "Applied Digital Technologies", cat: "ict", type: "vet" },
    {
      tag_name: "Telecommunications Network Build and Operation",
      cat: "ict",
      type: "vet",
    },
    { tag_name: "Telecommunications Technology", cat: "ict", type: "vet" },
    { tag_name: "Information Technology", cat: "ict", type: "vet" },
    { tag_name: "Telecommunications Network Design", cat: "ict", type: "vet" },
    {
      tag_name: "Telecommunications Engineering Technology",
      cat: "ict",
      type: "vet",
    },
    {
      tag_name: "Tourism (Australian Indigenous Culture)",
      cat: "sit",
      type: "vet",
    },
    { tag_name: "Hospitality", cat: "sit", type: "vet" },
    { tag_name: "Tourism", cat: "sit", type: "vet" },
    { tag_name: "Holiday Parks and Resorts", cat: "sit", type: "vet" },
    { tag_name: "Kitchen Operations", cat: "sit", type: "vet" },
    { tag_name: "Asian Cookery", cat: "sit", type: "vet" },
    { tag_name: "Travel", cat: "sit", type: "vet" },
    { tag_name: "Guiding", cat: "sit", type: "vet" },
    { tag_name: "Events", cat: "sit", type: "vet" },
    {
      tag_name: "Hospitality (Restaurant Front of House)",
      cat: "sit",
      type: "vet",
    },
    { tag_name: "Commercial Cookery", cat: "sit", type: "vet" },
    { tag_name: "Catering Operations", cat: "sit", type: "vet" },
    { tag_name: "Patisserie", cat: "sit", type: "vet" },
    { tag_name: "Travel and Tourism", cat: "sit", type: "vet" },
    { tag_name: "Travel and Tourism Management", cat: "sit", type: "vet" },
    {
      tag_name: "Holiday Parks and Resorts Management",
      cat: "sit",
      type: "vet",
    },
    { tag_name: "Event Management", cat: "sit", type: "vet" },
    { tag_name: "Hospitality Management", cat: "sit", type: "vet" },
    { tag_name: "Mental Health", cat: "chc", type: "vet" },

    { tag_name: "Data Analytics", cat: "ict", type: "tech" },
    {
      tag_name: "Programming and Software Development",
      cat: "ict",
      type: "tech",
    },
    { tag_name: "Cyber Security", cat: "ict", type: "tech" },
    { tag_name: "Cloud Computing", cat: "ict", type: "tech" },
    { tag_name: "AI and Machine Learning", cat: "ict", type: "tech" },
    { tag_name: "Project Management", cat: "ict", type: "tech" },
    {
      tag_name: "Digital Marketing, Operations and Support",
      cat: "ict",
      type: "tech",
    },
    { tag_name: "Web Development", cat: "ict", type: "tech" },
    { tag_name: "Product Management", cat: "ict", type: "tech" },
    { tag_name: "UX and UI", cat: "ict", type: "tech" },
    { tag_name: "Teamwork and Collaboration", cat: "ict", type: "tech" },
    { tag_name: "Social Media Marketing", cat: "ict", type: "tech" },
    { tag_name: "Google Analytics", cat: "ict", type: "tech" },
    { tag_name: "Amazon Web Services (AWS)", cat: "ict", type: "tech" },
    { tag_name: "Microsoft", cat: "ict", type: "tech" },
    { tag_name: "Salesforce", cat: "ict", type: "tech" },
    { tag_name: "GSuite", cat: "ict", type: "tech" },
    { tag_name: "Project Administration", cat: "ict", type: "tech" },
    { tag_name: "Product Development", cat: "ict", type: "tech" },
    { tag_name: "Website Design", cat: "ict", type: "tech" },
    { tag_name: "Frontend Web Development", cat: "ict", type: "tech" },
    { tag_name: "Backend Web Development", cat: "ict", type: "tech" },
    { tag_name: "Gitlab/Github", cat: "ict", type: "tech" },
    { tag_name: "Data Modelling", cat: "ict", type: "tech" },
    { tag_name: "Business Analyst", cat: "ict", type: "tech" },
    {
      tag_name: "Customer Care/Helpdesk (Customer Service)",
      cat: "ict",
      type: "tech",
    },
  ];
};

export const tagsToArray = (tagObj) => {
  // let tags = Object.values(createUserObject({ can_delivers: tagObj }))
  // let tags = Object.values(tagObj)
  //     .reduce((total, next) => total.concat(next))
  let tags = [];
  for (const [key, value] of Object.entries(tagObj)) {
    if (key !== "_id") {
      value.forEach((tag) => tags.push(tag));
    }
  }
  return tags;
};

export const getDays = (state) => {
  let days = [];
  [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
    "flexible_days",
  ].forEach((day) => {
    if (state[day]) {
      days.push(day);
    }
  });
  return days;
};

export const getListingData = (data, user, inst) => {
  const responsibilities = [data.responsibility_1, data.responsibility_2];
  if (data.responsibility_3) responsibilities.push(data.responsibility_3);
  const benefits = [data.benefit_1, data.benefit_2];
  if (data.benefit_3) benefits.push(data.benefit_3);
  const expertise = [data.expertise_1, data.expertise_2];
  if (data.expertise_3) expertise.push(data.expertise_3);
  let days = getDays(data);

  const listing_data = {
    inst_id: inst._id,
    is_vet: data.is_vet,
    qual_name: data.qual_name,
    course_code: data.course_code,
    location: data.location,
    publisher_id: user[`${user.role}_id`],
    title: data.title,
    online: data.online,
    delivery_mode: data.delivery_mode,
    description: data.description,
    responsibilities: responsibilities,
    benefits: benefits,
    expertise: expertise,
    pub_date: new Date(),
    close_date: data.close_date,
    start_date: data.start_date,
    end_date: data.end_date,
    days: days,
    weekly_hours: data.weekly_hours,
    level: data.level,
    tags: data.tags,
    salary_type: data.salary_type,
    salary_display_option: data.salary_display_option,
    interview_requested: !data.instant_hire,
    org_pro_visible: data.org_pro_visible,
    status: data.status,
    no_of_roles: data.no_of_roles,
    selected_tags: data.selected_tags || [],
    various_campus: data?.various_campus ?? false,
    display_various_dates: data?.display_various_dates ?? false,
  };

  if (user?.is_childcare_centre) {
    listing_data.is_ecec = true
  }

  // don't include salary_type when sending to backend, it's just for use in the form
  // make sure to reset pub_date to current date when publishing for the first time

  if (data.salary_type) {
    if (data.salary_type === "annual_salary") {
      listing_data.salary_min = data.salary_min;
      listing_data.salary_max = data.salary_max;
      listing_data.salary_unit = data.salary_unit;
      listing_data.hourly_rate_min = 0;
      listing_data.hourly_rate_max = 0;
      listing_data.hourly_rate_unit = "";
    } else if (data.salary_type === "hourly_salary") {
      listing_data.hourly_rate_min = data.salary_min;
      listing_data.hourly_rate_max = data.salary_max;
      listing_data.hourly_rate_unit = data.salary_unit;
      listing_data.salary_min = 0;
      listing_data.salary_max = 0;
      listing_data.salary_unit = "";
    }
  }

  return listing_data;
};

export const validateForm = (state, campus) => {
  let errors = false;
  let days = getDays(state);
  let tags = document.getElementById("tags");
  // console.log(campus)
  if (!state.location) {
    errors = true;
    notify.show("Please select a campus.");
  } else if (!campus.campus_shortname) {
    errors = true;
    notify.show("Your selected campus must have a street address.");
  } else if (days.length === 0) {
    errors = true;
    notify.show("Please select at least one day.");
  } else if (state.salary_type && !state.salary_unit) {
    errors = true;
    notify.show("Please select a unit of currency.");
  } else if (state.salary_type && !(state.salary_min && state.salary_max)) {
    errors = true;
    notify.show(
      `Please input a ${state.salary_min ? "maximum" : "minimum"} salary`
    );
  } else if (!tags.children.length) {
    errors = true;
    notify.show("Please select at least one tag.");
  } else if (tags.children.length > 15) {
    errors = true;
    notify.show("Please select no more than 15 tags.");
  }

  return errors;
};

export const filterJobCriterias = (job) => {
  const arrayOfJobTags = tagsToArray(job.tags);
  let kw = job.title + " " + arrayOfJobTags.join(" ");
  let loc = job.location || "";
  let cat = arrayOfJobTags
    .map((tag) => {
      let foundTag = getTags().find((t) => t.tag_name === tag);
      if (foundTag) return foundTag.cat;
    })
    .join(" ");

  return {
    keyword: kw.toLowerCase(),
    location: loc.toLowerCase(),
    category: cat.toLowerCase(),
  };
};
